import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Testimonials = () => {
    const { t } = useLanguage();
    const items = t.testimonials.items;
    const [active, setActive] = useState(0);

    const prev = () => setActive((a) => (a - 1 + items.length) % items.length);
    const next = () => setActive((a) => (a + 1) % items.length);

    return (
        <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-gradient-to-b from-ella-cream to-ella-sand">
            <div className="ella-container">
                <div className="grid lg:grid-cols-12 gap-12 items-start">
                    <div className="lg:col-span-4">
                        <span className="ella-overline" data-testid="testimonials-overline">{t.testimonials.overline}</span>
                        <h2 className="ella-headline text-4xl md:text-5xl lg:text-6xl mt-4 text-ella-ink" data-testid="testimonials-title">{t.testimonials.title}</h2>
                        <div className="hidden lg:flex gap-3 mt-10">
                            <button onClick={prev} data-testid="testimonial-prev" className="w-12 h-12 rounded-full border border-ella-line flex items-center justify-center text-ella-ink hover:border-ella-gold hover:text-ella-gold-dark transition-colors"><ChevronLeft className="w-5 h-5" strokeWidth={1.5} /></button>
                            <button onClick={next} data-testid="testimonial-next" className="w-12 h-12 rounded-full border border-ella-line flex items-center justify-center text-ella-ink hover:border-ella-gold hover:text-ella-gold-dark transition-colors"><ChevronRight className="w-5 h-5" strokeWidth={1.5} /></button>
                        </div>
                    </div>
                    <div className="lg:col-span-8 relative">
                        <div className="ella-card !p-10 md:!p-14 relative overflow-hidden" data-testid={`testimonial-active-${active}`}>
                            <Quote className="absolute -top-4 -right-4 w-32 h-32 text-ella-sand" strokeWidth={1} />
                            <div className="relative">
                                <div className="flex items-center gap-1 text-ella-gold">
                                    {[...Array(5)].map((_, s) => (<Star key={s} className="w-4 h-4 fill-ella-gold" strokeWidth={0} />))}
                                </div>
                                <p className="mt-7 font-serif italic text-2xl md:text-3xl lg:text-4xl text-ella-ink leading-tight">“{items[active].text}”</p>
                                <div className="mt-9 flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-ella-sand to-ella-gold/30 flex items-center justify-center font-display text-xl text-ella-ink">{items[active].name.charAt(0)}</div>
                                    <div>
                                        <p className="font-display text-xl text-ella-ink leading-none">{items[active].name}</p>
                                        <p className="ella-overline mt-2">{items[active].role}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-6 flex items-center justify-between">
                            <div className="flex gap-2">
                                {items.map((_, i) => (<button key={i} onClick={() => setActive(i)} data-testid={`testimonial-dot-${i}`} className={`h-1.5 rounded-full transition-all duration-500 ${i === active ? "w-10 bg-ella-gold" : "w-5 bg-ella-line hover:bg-ella-muted"}`} aria-label={`testimonial ${i + 1}`} />))}
                            </div>
                            <div className="flex lg:hidden gap-2">
                                <button onClick={prev} data-testid="testimonial-prev-mobile" className="w-10 h-10 rounded-full border border-ella-line flex items-center justify-center text-ella-ink"><ChevronLeft className="w-4 h-4" strokeWidth={1.5} /></button>
                                <button onClick={next} data-testid="testimonial-next-mobile" className="w-10 h-10 rounded-full border border-ella-line flex items-center justify-center text-ella-ink"><ChevronRight className="w-4 h-4" strokeWidth={1.5} /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
